"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var CardReentry_1 = __importDefault(require("../Icons/CardReentry"));
var CardReentryModalTitle = function (_a) {
    var subtitle = _a.subtitle, title = _a.title;
    return (React.createElement(design_language_1.Inset, null,
        React.createElement(design_language_1.InlineChildren, { alignItems: design_language_1.InlineChildren.Alignment.Center, justifyContent: design_language_1.InlineChildren.Justification.Center },
            React.createElement(CardReentry_1["default"], null)),
        React.createElement(design_language_1.StackChildren, null,
            React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageTitle, textAlign: design_language_1.Text.TextAlignments.Center }, title),
            React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageSubtext, textAlign: design_language_1.Text.TextAlignments.Center }, subtitle))));
};
exports["default"] = CardReentryModalTitle;
